export default "__VITE_ASSET__02a5e5d2__"